<template>
    <div>
        <img :src="data" alt="">
    </div>
</template>

<script>
export default {
	name: 'OptimizedImage',

	props: {
		data: String
	}
}
</script>
